import { useDispatch } from 'react-redux';

export const useAction = (actionCreator, dispatch = useDispatch()) => (...args) =>
  dispatch(actionCreator(...args));

const makeReducerCases = (cases, actions) => Object.entries(cases)
  .map(([key, value]) => ({ key: actions[key].TYPE, value }))
  .reduce((result, { key, value }) => ({
    ...result,
    [key]: value,
  }), {});

const makeReducerInternal = (cases, initialState) => (state = initialState, { type, payload }) => {
  const found = cases[type];
  return found ? found(state, payload) : state;
};
export const makeReducer = (cases, actions, initialState) => makeReducerInternal(makeReducerCases(cases, actions), initialState);

